module.exports = __webpack_public_path__ + "img/Download - Light Gray - Selected.d9346c50.png";